import { Currency } from '@components/Currency';
import { useAppSelector } from '@store/configureStore';
import { selectCurrencyFormatState } from '@store/settings/selectors';

import { CLP } from '@/types/currency';

import { type AppCurrencyProps } from './type';

const AppCurrency = ({
  children,
  emptyValue,
  fallbackValue = '-',
  currency = CLP,
}: AppCurrencyProps) => {
  const format = useAppSelector(selectCurrencyFormatState);

  return (
    <Currency
      format={format}
      emptyValue={emptyValue}
      fallbackValue={fallbackValue}
      currency={currency}
    >
      {children}
    </Currency>
  );
};

export { AppCurrency };
